import * as React from 'react';
import { observer } from 'mobx-react';
import { PageCheckoutPanelProps } from './page-checkout-panels';
import { PageCheckoutTracks } from './page-checkout-tracks';
import { Alert } from './alert';
import { style } from 'typestyle';
import {rem} from 'csx';
import { mediaTablet } from '../theme/media';
import {ImagePreloader} from '../types/fn';

export interface PageCheckoutContentStep0Props extends PageCheckoutPanelProps {
  PlayButton: any;
  BrandSponsoredLabel: any;
  onRemoveTrack(identity: string): void;
  onClickLink(event: React.MouseEvent<any>): void;
  preload: ImagePreloader;
  preloadWaveform: ImagePreloader;
  i18n?: {
    title: string;
  }
  onLabelCopyrightClick?:any;
}

const DEFAULT_I18N = {
  title: 'Your tracks'
};

@observer
export class PageCheckoutContentStep0 extends React.Component<PageCheckoutContentStep0Props, any> {
  render() {
    const { model, i18n = DEFAULT_I18N, PlayButton, BrandSponsoredLabel, onRemoveTrack, onClickLink, preload, preloadWaveform, onLabelCopyrightClick } = this.props;

    return (
      <div>
        {model.couponText && (
          <div className={PageCheckoutContentStep0.styles.coupon}>
            <Alert title={model.couponText.title} className={PageCheckoutContentStep0.styles.coupon} type="warning" position="top-left">
              <p>{model.couponText.message}</p>
            </Alert>
          </div>
        )}
        <h5>{i18n.title}</h5>
        <PageCheckoutTracks
          PlayButton={PlayButton}
          BrandSponsoredLabel={BrandSponsoredLabel}
          model={model}
          collapsed={model.expanded}
          onRemoveTrack={onRemoveTrack}
          preload={preload}
          preloadWaveform={preloadWaveform}
          onClickLink={onClickLink}
          onLabelCopyrightClick={onLabelCopyrightClick}
        />
      </div>
    )
  }

  static styles = {
    coupon: style(
      {
        marginBottom: rem(1.5)
      },
      mediaTablet({
        display: 'none'
      })
    )
  }
}